import { emptyDecorator } from '@/catalog/constants/emptyDecorator';
import { FieldType } from '@/catalog/constants/fieldTypes';
import { ALL_CONTEXTS } from '@/common/constants/context';
import Diamond from '@/product/entity/Diamond';
import Gem from '@/product/entity/Gem';
export const FIELD_MUNSELL_COORDINATES = {
    label: 'Munsell Coordinates',
    fullLabel: 'Munsell Coordinates',
    key: 'HVC',
    type: FieldType.Scalar,
    icon: 'octonus-color',
    getter(p) {
        return this.getterPlain(p);
    },
    getterPlain(p) {
        if ((p instanceof Diamond || p instanceof Gem) && p.fancyColorGrade) {
            return p.fancyColorGrade.getExactHVCString();
        }
        return null;
    },
    decorator: emptyDecorator,
    iteratee: null,
    contexts: ALL_CONTEXTS,
};
